import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
export const denormalizeTypeId = objectTypeId => ObjectTypeFromIds[objectTypeId] || objectTypeId;